__turbopack_context__.v({
  "rightNavGroup": "worknav-module__lh7d3G__rightNavGroup",
  "workNavBar": "worknav-module__lh7d3G__workNavBar",
});
